export enum AuthType {
    NONE = "NONE",
    BASIC_AUTH = "BASIC_AUTH",
    JWT = "JWT",
    OAUTH2 = "OAUTH2"
}